import {
  CHANAGEPASSWORD_FAIL,
  CHANAGEPASSWORD_REQUEST,
  CHANAGEPASSWORD_SUCCESS,
} from "../../constants/actions";

const initialState = {
  loading: false,
  newPass: false,
  error: false
};

const changePasswordReducer = (state = initialState, action) => {
  switch (action.type) {
    case CHANAGEPASSWORD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case CHANAGEPASSWORD_SUCCESS:
      return {
        loading: false,
        newPass: true,
        error: false,
      };
    case CHANAGEPASSWORD_FAIL:
      return {
        loading: false,
        newPass: false,
        error: true,
      };
    default:
      return state;
  }
};

export default changePasswordReducer;
